import dayjs from 'dayjs';

export const DEBOUNCE_TIME_SEARCH = 200; //0.2s
export const DEFAULT_KEY_ROUTER = 1;
export const DEFAULT_STATUS_ALL = 4;

export const CURRENT_DATE = dayjs(new Date());
export const DATE_FORMAT = 'YYYY-MM-DD';
export const MONTH_FORMAT = 'YYYY-MM';
export const DATE_FORMAT_NO_DATE = 'MM/YYYY';
export const DATE_TIME_FORMAT = 'DD/MM/YYYY';
export const DATE_TIME_FORMAT_WITH_TIME = 'DD/MM/YYYY HH:mm:ss';
export const blocks_per_package = 10;

export enum RequestStatus {
  Sending = 0,
  Processing = 1,
  Success = 2,
  Error = 3,
  Cancelling = 4,
  Cancelled = 5,
  //- The DU worker has picked the request up. Same lifecycle position as Processing for the
  //- UI: still in flight, still cancellable. Displayed as Processing.
  Extracting = 6,
}

export const DEBOUNCE_TIME_OUT = 600;
export const PAGE_LIMIT_DEFAULT = 1000;
export const PAGE_USED_PERCENT = 100;

export const VALUE_TO_MAP = {
  2: true,
  3: false,
};

export const DEFAULT_KEY = {
  PAGE_KEY: 'page',
  SIZE_KEY: 'size',
};

export const SEARCH_QUERY_DEFAULT = {
  PAGE: '1',
  SIZE: '10',
};

export const SEARCH_QUERY_PARAMS = {
  PAGE: 'page',
  SIZE: 'size',
  SORT: 'sorter',
  SEARCH: 'search',
  CREATED_BY: 'createdBy',
  STATUS: 'status',
  START_DATE: 'startDate',
  END_DATE: 'endDate',
  FROM: 'from',
  TO: 'to',
  DEPARTMENT: 'department',
  BILL_MONTH: 'billMonth',
  EXPIRED_DATE: 'expiredDate',
  CREATED_DATE: 'createdDate',
  DEPARTMENT_ID: 'departmentId',
  USER_SEARCH: 'userSearch',
  TAB_INDEX: 'tabIndex',
};

export const DEBUG_QUERY_PARAMS = {
  SHOW_ALL: 'showAll',
};
